import {Dispatch, FC, SetStateAction} from 'react';

import {Box, Dialog, styled, Typography, Drawer} from '@mui/material';
import {useTranslation} from 'react-i18next';

import Button from 'components/button/Button';

export const VoucherRemovalDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: '448px',
    padding: '16px 16px 24px 16px',
    borderRadius: '12px'
  }
}));

export const StyledBottomSheet = styled(Drawer)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px 16px 0px 0px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
    padding: '16px 16px 24px 16px'
  }
}));

export const VoucherActionButton = styled(Button)(() => ({
  margin: '0px 16px 0px 16px'
}));

export const DialogFooter = styled(Box)(({theme}) => ({
  '&': {
    display: 'flex',
    gap: '16px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.fontSize - 4
    }
  }
}));

type RemoveVoucherModalProps = {
  setShowRemovalModal: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  onConfirm: () => void;
  isReactNativeWebView: boolean;
  loading?: boolean;
};

export const RemoveVoucherModal: FC<RemoveVoucherModalProps> = ({
  onConfirm,
  setShowRemovalModal,
  open,
  isReactNativeWebView,
  loading = false
}) => {
  const {t} = useTranslation();
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : VoucherRemovalDialog;

  return (
    <ModalContainer open={open} anchor="bottom">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        maxWidth={isReactNativeWebView ? '100%' : '328px'}
        width="100%"
        gap="16px"
        marginBottom="32px"
      >
        <Box>
          <Typography fontWeight="bold" fontSize={20}>
            {t('omniChannelVoucher.removeCurrentVoucher')}
          </Typography>
        </Box>
        <Box>
          <Typography fontSize={14} textAlign="center">
            {t('omniChannelVoucher.applyDifferentVoucher')}
          </Typography>
        </Box>
      </Box>
      <DialogFooter>
        <VoucherActionButton
          onClick={() => setShowRemovalModal(false)}
          fullWidth
          type="button"
          color="primary"
          variant="contained"
          shape="rounded"
          disabled={loading}
        >
          {t('omniChannelVoucher.keep')}
        </VoucherActionButton>
        <VoucherActionButton
          onClick={() => onConfirm()}
          fullWidth
          type="button"
          color="primary"
          variant="outlined"
          shape="rounded"
          loading={loading}
          disabled={loading}
        >
          {t('omniChannelVoucher.remove')}
        </VoucherActionButton>
      </DialogFooter>
    </ModalContainer>
  );
};

export default RemoveVoucherModal;
